<!-- notes.component.html -->
<div class="container">
  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    multiple
    [accept]="allowedFileTypes.join(',')"
    (change)="onFilesSelected($event)"
    style="display: none"
  />

  <div class="top">
    <div class="card-input-wrapper" *ngIf="!noteOpen || isEditing">
      <input
        class="card-input"
        placeholder="Write a note!"
        (focus)="expandEditor()"
      />
      <mat-icon class="add-icon">add</mat-icon>
    </div>

    <app-html-editor
      *ngIf="noteOpen && !isEditing"
      [formControl]="notesContent"
      [height]="'100px'"
      [showNoteBackground]="true"
      placeholder="Description"
      [quillModule]="quillModule"
    ></app-html-editor>

    <!-- Pending Files Display (before upload) -->
    <div
      class="attachments-container"
      *ngIf="noteOpen && !isEditing && (pendingFiles.length > 0 || isUploading)"
    >
      <div class="attachments-header">
        <mat-icon>attach_file</mat-icon>
        <span>Attachments ({{ pendingFiles.length }}/5)</span>
        <mat-spinner *ngIf="isUploading" diameter="16"></mat-spinner>
      </div>

      <div class="attachments-list">
        <div
          class="attachment-chip"
          *ngFor="let file of pendingFiles; let i = index"
        >
          <mat-icon class="file-icon">{{ getFileIcon(file.type) }}</mat-icon>
          <span class="attachment-name" [title]="file.name">
            {{ file.name | slice : 0 : 20
            }}{{ file.name.length > 20 ? '...' : '' }}
          </span>
          <span class="attachment-size" *ngIf="file.size">
            ({{ formatFileSize(file.size) }})
          </span>
          <button
            class="remove-attachment-btn"
            (click)="removePendingFile(i)"
            [disabled]="isSaving"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Tab-style suggestions section -->
    <div
      class="suggestions-tabs-container"
      *ngIf="noteOpen && !isEditing && (userNoteUsage.length > 0 || loadingSuggestions)"
    >
      <div class="suggestions-tabs-header">
        <mat-icon>flash_on</mat-icon>
        <span>Quick notes</span>
      </div>

      <div class="suggestions-tabs-wrapper">
        <div class="suggestions-tabs" *ngIf="!loadingSuggestions">
          <div
            class="suggestion-tab"
            *ngFor="let suggestion of userNoteUsage"
            [title]="suggestion.text"
            (click)="insertSuggestion(suggestion)"
          >
            <span class="tab-text">{{ suggestion.text }}</span>
            <button class="remove-btn" (click)="removeSuggestion($event, suggestion)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="suggestions-loading-tabs" *ngIf="loadingSuggestions">
          <div class="loading-tab" *ngFor="let item of [1, 2, 3]">
            <span class="skeleton-text"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons" *ngIf="noteOpen && !isEditing">
      <button mat-button color="primary" (click)="cancel()" [disabled]="isSaving || isUploading">
        Cancel
      </button>
      <button
        mat-button
        (click)="triggerFileInput()"
        [disabled]="isSaving || isUploading || pendingFiles.length >= 5"
      >
        <mat-icon>attach_file</mat-icon>
        Attach
      </button>
      <button
        mat-button
        mat-flat-button
        color="primary"
        [disabled]="!notesContent.value || isSaving || isUploading"
        (click)="save()"
      >
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>

  <div class="bottom-div">
    <div *ngIf="total > 0">
      <app-item
        *ngFor="let note of notes; let i = index"
        [note]="note"
        [quillModule]="quillModule"
        (onEdit)="editRow($event)"
        (onDelete)="deleteRow($event)"
        [role]="userRole"
        (onSave)="save($event)"
        (onTogglePin)="togglePin($event)"
      >
      </app-item>

      <div style="text-align: center; cursor: pointer" *ngIf="showLoad">
        <mat-icon (click)="moreData()">cached</mat-icon>
      </div>
    </div>
    <div *ngIf="total == 0" class="{{ noteOpen && !isEditing ? 'image' : 'image-big' }}">
      <img
        class="{{ noteOpen && !isEditing ? 'img-big' : 'img' }}"
        src="../../../../../assets/images/backgrounds/notes.png"
      />
    </div>
  </div>
</div>